<template>
    <div class="bottom-bar">
        <p class="left-text">®ZECON - CNPJ: 06.125.289/0001-51</p>
        <p class="right-text">Copyright © 2023. Feito com 💙 pela Comp Júnior.</p>
    </div>
</template>
  
<script>
export default {
    name: "Bottom",
};
</script>
  
<style scoped>
.bottom-bar {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #343333;
    color: white;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 8%;
    box-sizing: border-box;
}

.left-text,
.right-text {
    font-family: 'Montserrat', sans-serif;
    font-size: 1.25vw;
    font-weight: 300;
    padding: 2vw 6vw 1vw 6vw;
    flex: 1;
}

.left-text {
    text-align: left;
}

.right-text {
    text-align: right;
}
</style>
  